import { endpoint,mappable } from '../decorators';
import { BaseViewModel } from './base-view-model';
import { CategoryViewModel } from './category-view-model';

@endpoint('CorrespondenceCategory')
export class CorrespondenceCategoryViewModel extends BaseViewModel {
  public CorrespondenceId = 0;
  public CategoryId = 0;

  @mappable('CategoryViewModel')
  public Category: CategoryViewModel = null;
}
